export default "__VITE_ASSET__922877e9__"